<p>compare-base-modal works!</p>
